/**
 * Start any application specific calls to via ready to avoid
 * boiler place throughout the core code.
 *
 */
/* eslint-disable no-unused-vars */
jQuery(document).ready((e) => {
  // prevent caching of ajax GET requests in IE
  $.ajaxSetup({
    cache: false,
  });

  DO.Fire('app:ready', [], true);
});

cssVars();
objectFitImages();
/* eslint-enable no-unused-vars */
